<template>
    <nav>
        <!--SIDEBAR-->
        <v-navigation-drawer app v-model="drawer" v-if="this.$store.state.logged" value="true" style="padding-top: 0px;margin-top: 0px;overflow: hidden">
            <w-sidebar-menu :menu="items" width="304px" :collapsed="false" :show-one-child="true" :rtl="false" ></w-sidebar-menu>
        </v-navigation-drawer>
        <!--TOOLBAR-->
        <v-toolbar app v-if="this.$store.state.logged">
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-spacer></v-spacer>
            <v-btn flat @click="logout">
                <span>Sair &nbsp;</span> &nbsp;
                <v-icon>input</v-icon>
            </v-btn>
        </v-toolbar>
    </nav>
</template>
<style>
    tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, .05);
    }
</style>
<script>
    import store from '@/store'
    import WSidebarMenu from "./Menu/SidebarMenu";
    export default {
        components: {WSidebarMenu},
        data() {
            return {
                isCollapse: true,
                value: '',
                active: '',
                clipped: true,
                drawer: true,
                right: true,
                title: 'i2data',
                provider: 'WCast',
                items: [
                    {
                        header: true,
                        user: this.$store.state.username,
                        last_access: this.$store.state.last_access,
                        class:'header-menu'
                    },
                    {
                        title: 'Visão geral',
                        icon: 'fa fa-desktop',
                        href: '/',
                        heading: true
                    },
                    {
                        title: 'Banners',
                        icon: 'fa fa-images',
                        href: '/banners',
                        heading: true,
                        child: [
                            {title: 'Adicionar', href: '/banners/add'},
                        ]
                    },
                    {
                        title: 'Dicas e novidades',
                        icon: 'fa fa-edit',
                        href: '/news',
                        child: [
                            {title: 'Adicionar', href: '/news/add'}
                        ]
                    },
                    {
                        title: 'Usuários',
                        icon: 'fa fa-users',
                        href: '/users',
                        heading: true,
                        child: [
                            {title: 'Adicionar', href: '/users/add'},
                        ]
                    },
                    {
                        title: 'Pesquisa de satisfação',
                        icon: 'fa fa-poll',
                        href: '/surveys',
                        heading: true
                    },
                    {
                        title: 'Avaliações',
                        icon: 'fa fa-star',
                        href: '/rantings',
                        heading: true
                    },
                    {
                        title: 'Integração Vista',
                        icon: 'fa fa-server',
                        href: '/apis'
                    }
                ]
            }
        },
        methods: {
            logout: function () {
                this.$store.commit('logout')
                this.$router.push({name: 'auth'})
            },
            setItem() {

            },
            handleClick(key, b) {
                console.log(key, b);
            }
        },
        updated: function () {
            var self = this
            setTimeout(function () {
                if (store.getters.getRole === 'A') {
                    self.items = self.itemsA
                } else if (store.getters.getRole === 'C') {
                    self.items = self.itemsC
                }
            }, 1000)
        },
        beforeCreate: function () {
            var self = this
            self.items = []
            setTimeout(function () {
                if (store.getters.getRole === 'C') {
                    self.drawer = false
                }
            }, 2000)
        }
    }
</script>
